import { render } from "./MetoceanTable.vue?vue&type=template&id=2bd9262e&scoped=true&ts=true"
import script from "./MetoceanTable.vue?vue&type=script&lang=ts"
export * from "./MetoceanTable.vue?vue&type=script&lang=ts"

import "./MetoceanTable.vue?vue&type=style&index=0&id=2bd9262e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd9262e"]])

export default __exports__